import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgConversation = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.741 3.722a7.67 7.67 0 0 1 6.585 3.729l-.107-.001c-.546 0-1.077.06-1.589.172l-.055-.071a6.17 6.17 0 0 0-4.833-2.329v-.75.75a6.172 6.172 0 0 0-5.137 9.59.75.75 0 0 1 .078.68l-.696 1.85 2.586-.467a.75.75 0 0 1 .463.064c.738.36 1.54.57 2.358.617a7.3 7.3 0 0 0 .817 1.496 7.67 7.67 0 0 1-3.605-.658l-3.652.66a.75.75 0 0 1-.836-1.002l1.03-2.74A7.672 7.672 0 0 1 9.74 3.722m3.898 5.822a5.654 5.654 0 0 1 7.37 7.89l.693 1.844a.75.75 0 0 1-.836 1.002l-2.52-.456a5.654 5.654 0 0 1-4.707-10.28m2.457.189v.75a4.155 4.155 0 1 0 1.82 7.887.75.75 0 0 1 .464-.064l1.453.262-.357-.95a.75.75 0 0 1 .077-.68 4.155 4.155 0 0 0-3.457-6.454z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgConversation;
